import React from 'react'
import * as UI from '@/components/UI'
import { Section, Banner, Play } from './Video.css'

const SeriousGamesTemplateVideo = ({ content }) => {
  if (!content.video_id || !content.video_image) return null
  return (
    <Section>
      <UI.Container>
        <UI.Modal
          handler={
            <Banner>
              <UI.Image src={content.video_image} />
              <Play />
            </Banner>
          }
        >
          <UI.Youtube id={content.video_id} />
        </UI.Modal>
      </UI.Container>
    </Section>
  )
}

export default SeriousGamesTemplateVideo
